export enum TaskTypes {
  Parent = 'Parent',
  SubTask = 'SubTask',
}
